document.addEventListener("alpine:init", () => {
    Alpine.data("territorySwitcherMobile", (current, langs) => ({
        active: false,
        current: current,
        availableLangs: langs,
        browserLang: navigator.language || navigator.userLanguage,
        dropdownOpen: false,
        mobileNavOpen: false,
        init() {
            console.log("Current browser lang " + this.current);

            if (this.browserLang.toLowerCase() != this.current.toLowerCase()) {
                if (
                    this.availableLangs.includes(this.browserLang.toLowerCase())
                ) {
                    this.active = true;
                }
            }

            window.addEventListener("pegasus-mobnav-open", (event) => {
                this.mobileNavOpen = true;
            });

            window.addEventListener("pegasus-mobnav-close", (event) => {
                this.mobileNavOpen = false;
            });
        },
        openDropdown() {
            if (this.dropdownOpen) {
                this.dropdownOpen = false;
                //window.dispatchEvent(new CustomEvent("pegasus-lang-close"));
            } else {
                this.dropdownOpen = true;
                //window.dispatchEvent(new CustomEvent("pegasus-lang-open"));
            }
        },
        closeSwitcher() {
            this.active = false;
            //window.dispatchEvent(
            //    new CustomEvent("pegasus-territory-switcher-close")
            //);
        },
    }));
});
